module.exports = __webpack_public_path__ + "img/more.67cd5cd2.svg";